import styled, { css } from 'styled-components';
export const Container = styled.div`
  display:${({ visibility }) => visibility ? ' ' : 'none'};
  width: 100%;
  height:100%;
  overflow-y:auto;
  overflow-x:hidden;
  padding: 0.5rem;
  &::-webkit-scrollbar{
    width: 5px;
    height: 5px;
  }
  &::-webkit-scrollbar-thumb{
    background-color: rgb(0, 0, 0,0.2);
  }
`;
export const Controls = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: .5rem;
  padding: .5rem;
  background-color: #1D86FF;
  border-radius: 4px;
  margin-bottom: 0.2rem;
  > div:nth-child(1){
    display: flex;
    justify-content: space-between;
    .tiRF {
      width: 8rem;
    }
    .icRf{
      font-size: 2.5rem;
      color: #ffffff;
      cursor: pointer;
      &:hover{
        transform: rotate(3.142rad);
        transition-duration: 1s;
      }
    }
  }
`;
export const Options = styled.ul`
  position: absolute;
  display: flex;
  width: 5rem;
  height: 0px;
  top:2.4rem;
  left:2px;
  z-index: 9999999;
  flex-direction: column;
  border-radius: 0px 0px 4px 4px;
  transition: height 240ms ease-in-out;
  overflow: hidden;
  background-color: #ffffff;
  color: #495057;
  li{
    display: flex;
    width: 100%;
    font-size: 1rem;
    margin-top: 0.5rem;
    display: flex;
    width: 100%;
    height: 2rem;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    &:hover{
      background-color: #1D86FF;
      color:#ffffff;
    }
  }
  ${({ isOpen }) => isOpen &&
    css`
      height: 130px;
      box-shadow: 1px 2px 4px rgb(0 0 0 / 20%);
    `
  }
`;
export const Progress = styled.div`
  display: flex;
  width: 100%;
  background-color: #f2f2f2;
  height: 0.5rem;
  align-items: center;
  border-radius: 2px;

  span {
    display: flex;
    height: 0.5rem;
    background-color: #1D86FF;
    border-radius: 2px;
    animation: mymove ${({ time }) => time}s linear infinite;
    animation-fill-mode: forwards;
  }

  @keyframes mymove {
    0% {
      width: 0%;
    }
    100% {
      width: 100%;
    }
  }
`;
